<template>
    <div class="toggle" :class="wrapperClasses" :style="wrapperStyles">
        <div class="label-desc">
            <div class="label" :for="name" v-if="label" :style="labelStyles">
                <span class="inner">{{ label }}</span>
            </div>
            <i
                class="extra-info far fa-question-circle"
                v-if="extraInfo"
                @click="$emit('extra-info-click')"
                :style="extraInfoStyles"
            />
            <div class="description" v-if="description">{{ description }}</div>
        </div>
        <div>
            <input type="checkbox" :name="name" :checked="checked" :ref="name" />
            <label :for="name" :class="{ [size]: true, disabled }" @click="toggle"></label>
        </div>
    </div>
</template>

<script>
    import FormControl from '../mixins/FormControl.vue';

    export default {
        name: 'FormToggle',
        model: {
            prop: 'checked',
            event: 'change'
        },
        data() {
            return {};
        },
        mixins: [FormControl],
        props: {
            checked: {
                validator(value) {
                    return ['boolean', 'undefined'].includes(typeof value);
                }
            },
            size: {
                type: String,
                default: 'small', // "small" or "medium"
            }
        },
        methods: {
            toggle() {
                if (this.disabled) return;
                this.$refs[this.name].checked = !this.$refs[this.name].checked;
                this.$emit('change', this.$refs[this.name].checked);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../scss/formControl';

    input {
        height: 0;
        width: 0;
        visibility: hidden;
        position: absolute;

        &:checked + label {
            background: $color-highlight;

            &:after {
                left: calc(100% - 4px);
                transform: translateX(-100%);
            }
        }
    }

    label {
        cursor: pointer;
        text-indent: -9999px;
        width: 70px;
        height: 36px;
        background: grey;
        display: inline-block;
        border-radius: 100px;
        position: relative;
        box-shadow: inset 0 0 10px 0px rgba(0, 0, 0, 0.2);

        &.small {
            width: 52px;
            height: 27px;

            &:after {
                width: 21px;
                height: 21px;
            }
        }

        &:after {
            content: '';
            position: absolute;
            top: 3px;
            left: 4px;
            width: 30px;
            height: 30px;
            background: $color-white;
            border-radius: 30px;
            transition: 0.3s ease-out;
            box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        }

        &.disabled {
            cursor: not-allowed;
        }
    }

    .control-wrapper .label {
        padding-left: 0;
    }
</style>